import { gql } from '@apollo/client';
import { getRichTextQueryString, getShortTextLabelsQueryString } from './utils';

export const getContactFooterCollection = gql`
	query getContactFooterCollection($lang: String, $slug: String) {
		contactFooterCollection(
			locale: $lang
			limit: 1
			where: { landEnum: { landList_contains: $slug } } 
		) {
			items {
				headline(locale: $lang)
				paymentMethods(locale: $lang)
				textLeftButton
				textRightButton
				linkLeftButton
				linkRightButton
				richtextList {
					${getRichTextQueryString()} 
				}
			}
		}
		vignettesOrderManagementCollection(locale: $lang, limit: 1) {
			items {
				${getShortTextLabelsQueryString(['headlineIntro'])}
			}
		}
	}
`;
